import styled from 'styled-components';
import Success from '../images/success.svg';
import Pending from '../images/pending.svg';
import Error from '../images/error.svg';
import Button from '../components/button';

const Confirmation = ({ status }) => {
    return (
        <PageContainer>
            {status === 'pay-success' && (
                <>
                    <img
                        src={Success}
                        alt="Success"
                        style={{ width: '100px' }}
                    />
                    <h1>Thank You!</h1>
                    <div>Your payment has been successfully submitted.</div>
                    <Button
                        onClick={() => window.location.reload()}
                        variant="contained"
                    >
                        Start Over
                    </Button>
                </>
            )}
            {status === 'pay-pending' && (
                <>
                    <img
                        src={Pending}
                        alt="Pending"
                        style={{ width: '100px' }}
                    />
                    <h1>Thank You!</h1>
                    <div>
                        Your payment has been successfully submitted and is
                        currently processing.
                    </div>
                    <Button
                        onClick={() => window.location.reload()}
                        variant="contained"
                    >
                        Start Over
                    </Button>
                </>
            )}
            {status === 'pay-update' && (
                <>
                    <img
                        src={Pending}
                        alt="Pending"
                        style={{ width: '100px' }}
                    />
                    <h1>Thank You!</h1>
                    <div>Your payment profile has been updated.</div>
                    <Button
                        onClick={() => window.location.reload()}
                        variant="contained"
                    >
                        Start Over
                    </Button>
                </>
            )}
            {status === 'pay-error' && (
                <>
                    <img src={Error} alt="Pending" style={{ width: '100px' }} />
                    <h1>Payment Failed!</h1>
                    <div>Unable to process payment request.</div>
                    <Contact>
                        <div>Please contact:</div>
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g opacity="0.4">
                                <path
                                    d="M16.0265 12.7167L13.9098 12.475C13.4015 12.4167 12.9015 12.5917 12.5432 12.95L11.0098 14.4833C8.6515 13.2833 6.71817 11.3583 5.51817 8.99166L7.05983 7.45C7.41817 7.09166 7.59317 6.59166 7.53483 6.08333L7.29317 3.98333C7.19317 3.14166 6.48483 2.50833 5.63483 2.50833H4.19317C3.2515 2.50833 2.46817 3.29166 2.5265 4.23333C2.96817 11.35 8.65983 17.0333 15.7682 17.475C16.7098 17.5333 17.4932 16.75 17.4932 15.8083V14.3667C17.5015 13.525 16.8682 12.8167 16.0265 12.7167Z"
                                    fill="#1A1A1A"
                                />
                            </g>
                        </svg>
                        <div>(855) 553-2735</div>
                    </Contact>
                </>
            )}
        </PageContainer>
    );
};

const PageContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    text-align: center;

    h2 {
        margin: 0;
    }
`;

const Contact = styled.div`
    display: flex;
    gap: 5px;
    align-items: center;
    margin-top: 10px;
    background: rgba(0, 131, 143, 0.1);
    font-size: 14px;
    padding: 5px 10px;
    border-radius: 5px;

    :first-child {
        flex: 1;
        padding-right: 10px;
    }

    :last-child {
        font-weight: bold;
    }
`;

export default Confirmation;
